import EnhancedTextField from "@components/anti/forms/react-hook-form/text-field"
import { useClickOutside } from "@components/hooks/hooks"
import { sendDataLayer, sendDatalayerSearch } from "lib/function"
import { useRouter } from "next/router"
import React, { useEffect, useRef } from "react"

const SearchMenu = ({ handleSearch, navExpand, search }) => {
  const ref = useRef(null)
  const resultUrl = "/result"

  //Utils
  const Router = useRouter()
  const { locale } = Router

  //States
  const [state, setState] = React.useState({
    searchType: "",
  })
  const searchTimeoutRef = useRef(null)

  //Functions
  const executeSearch = () => {
    handleSearch()
    sendDatalayerSearch(state.searchType)
    Router.push(`${resultUrl}?type=${state.searchType}`)
  }

  const handleEnterSearch = (e) => {
    if (e.key === "Enter") {
      // Clear any existing timeout
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current)
      }

      // Debounce the search execution
      searchTimeoutRef.current = setTimeout(() => {
        executeSearch()
      }, 100)
    }
  }

  const handleIconClick = () => {
    // Clear any existing timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current)
    }

    // Debounce the search execution
    searchTimeoutRef.current = setTimeout(() => {
      executeSearch()
    }, 100)
  }

  useClickOutside(ref, () => {
    if (search.clicked) handleSearch()
  })

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current)
      }
    }
  }, [])

  return (
    <div className={`search-nav-mobile d-${navExpand}-none`} ref={ref}>
      <EnhancedTextField
        onChange={(e) =>
          setState((prev) => ({ ...prev, searchType: e.target.value }))
        }
        id="search"
        name="search"
        variant="underline"
        placeholder={locale === "id" ? "Cari disini..." : "Search here..."}
        icon={{
          position: "adornment-end",
          el: <i className="air ai-search" onClick={handleIconClick}></i>,
        }}
        onKeyPress={handleEnterSearch}
        inputClassName="form-search white"
      />
    </div>
  )
}

export default SearchMenu
